import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import SignalCellularAltOutlinedIcon from '@mui/icons-material/SignalCellularAltOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import { Link } from 'react-router-dom';
import { KC_COLORS } from '../theme';

export function ArticlePageHeader({ article }) {
  return (
    <div className="kc-article-header pt-28 md:pt-32 pb-2 text-left">
      <nav aria-label="Breadcrumb" className="kc-article-breadcrumb mb-5 md:mb-6">
        <ol
          className="flex flex-wrap items-center gap-x-2 gap-y-1 kc-type-body font-semibold"
          style={{ color: KC_COLORS.navy700 }}
        >
          {article.breadcrumbs.map((crumb, index) => {
            const isLast = index === article.breadcrumbs.length - 1;
            return (
              <li key={`${crumb.label}-${index}`} className="inline-flex items-center gap-2">
                {index > 0 ? (
                  <span className="font-medium" style={{ color: KC_COLORS.gray600 }}>
                    &gt;
                  </span>
                ) : null}
                {crumb.path && !isLast ? (
                  <Link
                    to={crumb.path}
                    className="transition-opacity hover:opacity-80"
                    style={{ color: KC_COLORS.navy700 }}
                  >
                    {crumb.label}
                  </Link>
                ) : (
                  <span style={{ color: isLast ? KC_COLORS.gray600 : KC_COLORS.navy700 }}>
                    {crumb.label}
                  </span>
                )}
              </li>
            );
          })}
        </ol>
      </nav>

      <h1 className="kc-article-title kc-type-h1 break-words">
        {article.h1 || article.title}
      </h1>

      {article.summary ? (
        <p className="kc-article-summary kc-type-body max-w-3xl mt-4 md:mt-5 break-words">
          {article.summary}
        </p>
      ) : null}

      <p className="kc-article-updated mt-3 kc-type-caption">
        Updated: {article.lastUpdated} • {article.readTime}
      </p>

      <div className="kc-article-meta mt-5 md:mt-6 flex flex-wrap items-center gap-2 sm:gap-3 md:gap-4">
        <span
          className="inline-flex max-w-full items-center gap-2 rounded-full border bg-white px-3 py-1.5 sm:px-3.5 sm:py-2 kc-type-caption font-medium"
          style={{ borderColor: KC_COLORS.border, color: KC_COLORS.primaryNavy }}
        >
          <SignalCellularAltOutlinedIcon
            className="shrink-0"
            sx={{ fontSize: 18, color: KC_COLORS.successGreen }}
          />
          <span className="min-w-0 break-words">{article.difficulty}</span>
        </span>
        <span
          className="inline-flex max-w-full items-center gap-2 rounded-full border bg-white px-3 py-1.5 sm:px-3.5 sm:py-2 kc-type-caption font-medium"
          style={{ borderColor: KC_COLORS.border, color: KC_COLORS.primaryNavy }}
        >
          <AccessTimeOutlinedIcon
            className="shrink-0"
            sx={{ fontSize: 18, color: KC_COLORS.teal }}
          />
          <span className="min-w-0 break-words">{article.readTime}</span>
        </span>
        <span
          className="inline-flex max-w-full items-center gap-2 rounded-full border bg-white px-3 py-1.5 sm:px-3.5 sm:py-2 kc-type-caption font-medium"
          style={{ borderColor: KC_COLORS.border, color: KC_COLORS.primaryNavy }}
        >
          <GroupsOutlinedIcon
            className="shrink-0"
            sx={{ fontSize: 18, color: KC_COLORS.navy700 }}
          />
          <span className="min-w-0 break-words">{article.audience}</span>
        </span>
        <button
          type="button"
          className="inline-flex items-center gap-2 rounded-full border bg-white px-3 py-1.5 sm:px-3.5 sm:py-2 kc-type-caption font-medium transition-opacity hover:opacity-80"
          style={{ borderColor: KC_COLORS.border, color: KC_COLORS.primaryNavy }}
          onClick={() => {}}
          aria-label="Share article"
        >
          <ShareOutlinedIcon sx={{ fontSize: 18, color: KC_COLORS.primaryNavy }} />
          Share
        </button>
      </div>
    </div>
  );
}
